var map = {
	"./atlanta/attrition-rate.json": 1377,
	"./houston/attrition-rate.json": 75053,
	"./new-york/attrition-rate.json": 30235,
	"./san-francisco/attrition-rate.json": 39717,
	"./seattle/attrition-rate.json": 87494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94314;